import { render, staticRenderFns } from "./BrokerageMain.vue?vue&type=template&id=0e779001&"
import script from "./BrokerageMain.vue?vue&type=script&lang=js&"
export * from "./BrokerageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports